import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { pick } from '../tools';
import Config from './base.config';
import { browser } from '../const';
import protocol from '../protocol/dingtalk.protocol';
import { loadDingTalkConfig } from '../service/config';
import { EcoType } from '../const/enums';
/** dd.config 接口列表，需要鉴权的SDK接口 */

var jsApiList = ['runtime.info', 'device.base.getUUID', 'device.base.getInterface', 'device.nfc.nfcWrite', 'runtime.permission.requestOperateAuthCode', 'biz.util.scanCard', 'device.geolocation.get', 'device.geolocation.start', 'device.geolocation.stop', 'biz.map.locate', 'device.geolocation.get', 'device.geolocation.start', 'device.geolocation.stop', 'biz.map.locate', 'biz.map.search', 'biz.map.view', 'biz.clipboardData.setData', 'biz.util.open', 'biz.conference.openLink', 'biz.telephone.call', 'biz.telephone.showCallMenu', 'biz.telephone.checkBizCall', 'biz.telephone.quickCallList', 'biz.ding.create', 'biz.ding.post', 'biz.contact.choose', 'biz.contact.chooseMobileContacts', 'biz.contact.complexPicker', 'biz.contact.departmentsPicker', 'biz.contact.createGroup', 'biz.contact.setRule', 'biz.contact.rolesPicker', 'biz.contact.externalComplexPicker', 'biz.contact.externalEditForm', 'biz.customContact.choose', 'biz.customContact.multipleChoose', 'biz.chat.pickConversation', 'biz.chat.chooseConversationByCorpId', 'biz.chat.openSingleChat', 'biz.chat.toConversation', 'biz.cspace.saveFile', 'biz.cspace.preview', 'biz.cspace.chooseSpaceDir', 'biz.util.uploadAttachment', 'device.audio.startRecord', 'device.audio.stopRecord', 'device.audio.onRecordEnd', 'device.audio.download', 'device.audio.play', 'device.audio.pause', 'device.audio.resume', 'device.audio.stop', 'device.audio.onPlayEnd', 'device.audio.translateVoice', 'biz.conference.videoConfCall', 'biz.live.startClassRoom', 'biz.alipay.pay', 'biz.util.encrypt', 'biz.util.decrypt', 'biz.auth.requestAuthInfo', 'biz.auth.requestAuthInfo', 'biz.auth.requestAuthInfo', 'biz.conference.getCloudCallInfo', 'biz.conference.createCloudCall', 'biz.conference.getCloudCallList'];
/*
// 无需鉴权的SDK协议，可以直接调用
const jsApiList_dd_anonymous = [
  'dd.version',
  'device.notification.alert',
  'device.notification.confirm',
  'device.notification.prompt',
  'device.notification.vibrate',
  'device.notification.toast',
  'device.notification.actionSheet',
  'device.notification.showPreloader',
  'device.notification.hidePreloader',
  'device.notification.modal',
  'device.notification.extendModal',
  'biz.util.multiSelect',
  'device.accelerometer.watchShake',
  'device.accelerometer.clearShake',
  'device.connection.getNetworkType',
  'device.base.getWifiStatus',
  'device.base.getPhoneInfo',
  'device.nfc.nfcRead',
  'device.base.openSystemSetting',
  'device.base.openSystemSetting',
  'biz.util.datepicker',
  'biz.util.timepicker',
  'biz.util.datetimepicker',
  'biz.calendar.chooseOneDay',
  'biz.calendar.chooseDateTime',
  'biz.calendar.chooseHalfDay',
  'biz.calendar.chooseInterval',
  'biz.navigation.setLeft',
  'addEventListener',
  'removeEventListener',
  'biz.navigation.setTitle',
  'biz.navigation.setIcon',
  'biz.navigation.goBack',
  'biz.navigation.close',
  'biz.navigation.replace',
  'biz.navigation.quit',
  'ui.input.plain',
  'ui.progressBar.setColors',
  'ui.pullTorefresh.enable',
  'ui.pullToRefresh.disable',
  'ui.pullToRefresh.stop',
  'ui.webViewBounce.disable',
  'ui.webViewBounce.enable',
  'runtime.permission.requestAuthCode',
  'biz.util.scan',
  'util.domainStorage.setItem',
  'util.domainStorage.getItem',
  'util.domainStorage.removeItem',
  'device.geolocation.status',
  'biz.util.share',
  'biz.util.chosen',
  'biz.microApp.openApp',
  'biz.util.isLocalFileExist',
  'biz.util.openLocalFile',
  'biz.util.downLoadFile',
  'biz.util.previewImage',
  'biz.util.openLink',
  'biz.util.openModal',
  'biz.util.openSlidePanel',
  'device.screen.rotateView',
  'device.screen.resetView',
  'biz.realm.getUserExclusiveInfo'
]
*/

/** DingTalkConfig 对象 单例模式 */
// const configSdkPath = 'https://g.alicdn.com/dingding/dingtalk-jsapi/2.13.42/dingtalk.open.js';

/** DingTalkConfig 对象，onReady 函数判断是否SDK加载并鉴权成功 */

export var DingTalkConfig = /*#__PURE__*/function (_Config) {
  _inheritsLoose(DingTalkConfig, _Config);

  function DingTalkConfig(options) {
    var _this;

    _this = _Config.call(this, options) || this;

    _this.protocol = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(protocolName, data) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!jsApiList.includes(protocolName)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return this.onReady();

              case 3:
                _context.next = 7;
                break;

              case 5:
                _context.next = 7;
                return this.loadDingTalkSDK();

              case 7:
                return _context.abrupt("return", protocol(protocolName, data));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.configType = EcoType.dingTalk;
    _this.support = !!browser.dingTalk;
    _this.dingTalkSdkReady = false;
    _this.configOK = false;
    _this.lastDingTalkAgentConfigTime = null;
    return _this;
  }
  /** SDK是否准备就绪 */


  var _proto = DingTalkConfig.prototype;

  /** 
   * 当前类的ready事件，整套鉴权
   * @returns this.configOK:agent 鉴权是否成功
   */
  _proto.onReady =
  /*#__PURE__*/
  function () {
    var _onReady = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.loadDingTalkSDK();

            case 2:
              if (!(this.dingTalkSdkReady && !this.configOK)) {
                _context2.next = 6;
                break;
              }

              _context2.next = 5;
              return this.dingTalkConfig(this.orgId, this.agentId);

            case 5:
              this.configOK = _context2.sent;

            case 6:
              return _context2.abrupt("return", this.configOK);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function onReady() {
      return _onReady.apply(this, arguments);
    }

    return onReady;
  }()
  /**
   * 加载SDK
   * @returns this.dingTalkSdkReady : SDK是否准备就绪
   */
  ;

  _proto.loadDingTalkSDK =
  /*#__PURE__*/
  function () {
    var _loadDingTalkSDK = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (this.dingTalkSdkReady) {
                _context3.next = 7;
                break;
              }

              _context3.t0 = !!window.dd;

              if (_context3.t0) {
                _context3.next = 6;
                break;
              }

              _context3.next = 5;
              return DingTalkConfig.loadSDK();

            case 5:
              _context3.t0 = _context3.sent;

            case 6:
              this.dingTalkSdkReady = _context3.t0;

            case 7:
              return _context3.abrupt("return", this.dingTalkSdkReady);

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function loadDingTalkSDK() {
      return _loadDingTalkSDK.apply(this, arguments);
    }

    return loadDingTalkSDK;
  }()
  /**
   * 鉴权，dd.config
   * @returns this.configOK : config 鉴权是否成功
   */
  ;

  _proto.dingTalkConfig =
  /*#__PURE__*/
  function () {
    var _dingTalkConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(orgId, agentId) {
      var _this2 = this;

      var configResult, newConfig, defaultConfig, config, myDingTalkConfig;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (browser.dingTalk) {
                _context4.next = 3;
                break;
              }

              this.log('dingTalkConfig: not dingTalk client');
              return _context4.abrupt("return", false);

            case 3:
              if (!this.configOK) {
                _context4.next = 5;
                break;
              }

              return _context4.abrupt("return", this.configOK);

            case 5:
              _context4.next = 7;
              return loadDingTalkConfig({
                agentId: agentId,
                orgId: orgId
              });

            case 7:
              configResult = _context4.sent;

              if (configResult) {
                _context4.next = 11;
                break;
              }

              console.error('load weixin config error', configResult);
              return _context4.abrupt("return", false);

            case 11:
              /*
                  agentId  必填，微应用ID
                  corpId  必填，钉钉的corpID
                  timeStamp  必填，生成签名的时间戳
                  nonceStr  必填，生成签名的随机串
                  signature 必填，签名，见 附录-JS-SDK使用权限签名算法
              */
              newConfig = pick(configResult, ['agentId', ['appId', 'corpId'], ['timestamp', 'timeStamp'], ['noncestr', 'nonceStr'], 'signature']);
              defaultConfig = {
                beta: true,
                // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
                debug: !!localStorage.isDebug,
                // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                jsApiList: jsApiList.concat(this.apiList) // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来

              };
              config = _extends({}, defaultConfig, newConfig);

              myDingTalkConfig = function myDingTalkConfig() {
                return new Promise(function (resolve, reject) {
                  console.info('dd.config', config);
                  window.dd.config(config);
                  window.dd.ready(function () {
                    // 记录最后一次鉴权成功的时间点
                    _this2.lastDingTalkAgentConfigTime = new Date().valueOf();
                    resolve(true);
                  });
                  window.dd.error(function (err) {
                    _this2.log('dd.config fail:', err, config);

                    reject(false);
                  });
                });
              };

              _context4.next = 17;
              return myDingTalkConfig();

            case 17:
              this.configOK = _context4.sent;
              this.log('dd.config ok:', this.configOK);
              return _context4.abrupt("return", this.configOK);

            case 20:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function dingTalkConfig(_x3, _x4) {
      return _dingTalkConfig.apply(this, arguments);
    }

    return dingTalkConfig;
  }();

  return DingTalkConfig;
}(Config);
/** DingTalkConfig 对象 单例模式 */

var configInstanse = null;
/**
 * 返回鉴权单例对象
 * @param data: string: agentId; Configure.Options 配置参数，只有在初次鉴权时才有效
 * @returns DingTalkConfig 配置对象
 */

var dingTalk = function dingTalk(data) {
  var options = typeof data === 'string' ? {
    agentId: data
  } : data;
  configInstanse = configInstanse || new DingTalkConfig(options);
  return configInstanse;
};

export default dingTalk;